import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './ProviderRequestInfo.html';
import { Inject } from 'vue-di-container';
import ProviderRequestsService from '../ProviderRequestsService';
import { ProviderRequestAttachment, ProviderRequestsModel } from '../ProviderRequestsModel';
import FileSaver from 'file-saver';
import { ProviderAttachmentCategoryType } from '@/shared/Enums/ProviderAttachmentCategoryType';
import OperatorService from '@/Services/OperatorService';
import UserService from '@/shared/userService/UserService';
import UserModel from '@/shared/userService/Model/UserModel';
import VirtualOperatorRules from '@/shared/VirtualOperatorRules';
import { Toaster } from '@/Services/toast';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ProviderRequestsService,
        OperatorService,
        UserService,
    ],
})
export default class ProviderRequestInfo extends Vue {

    public get canEditVirtualOperator(): boolean {
        const role = this.user && this.user.details ? this.user.details.Role : '';
        return VirtualOperatorRules.canEditVirtualOperator(
            this.providerRequest.providerRequestStatus,
            role);
    }

    public get virtualOperatorDisplayName(): string {
        if (this.providerRequest.virtualOperatorName) {
            return this.providerRequest.virtualOperatorName;
        }
        if (this.providerRequest.virtualOperatorId) {
            const op = this.operatorOptions.find((o) => o.id === this.providerRequest.virtualOperatorId);
            return op ? op.name : '';
        }
        return '';
    }

    public get rejectReasonIsValid(): boolean {
        return this.rejectResone !== '';
    }

    @Inject(ProviderRequestsService) public providerRequestsService!: ProviderRequestsService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Inject(UserService) public userService!: UserService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: '' })
    public id!: string;

    public providerRequest: ProviderRequestsModel = {} as ProviderRequestsModel;
    public operatorOptions: Array<{ id: number; name: string }> = [];
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            TenantId: '',
            ProviderId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };

    public approveDialog: boolean = false;
    public rejectdialog: boolean = false;
    public rejectResone: string = '';

    public created() {
        this.$emit('childinit', this.layoutSup);
    }

    public async mounted() {
        this.user = await this.userService.getUser() as any;
        this.providerRequest = await this.providerRequestsService.GeById(this.id);
        if (!this.providerRequest) {
            return;
        }
        if (!this.providerRequest.providerRequestAttachments) {
            (this.providerRequest as any).providerRequestAttachments = [];
        }
        if (this.providerRequest.isVirtualOperator === undefined || this.providerRequest.isVirtualOperator === null) {
            this.providerRequest.isVirtualOperator = false;
        }
        const operators = await this.operatorService.getAll();
        if (operators && operators.isSuccess && operators.result) {
            this.operatorOptions = operators.result.map((o: any) => ({ id: o.id, name: o.name }));
        }
    }

    public onVirtualOperatorToggle() {
        if (!this.providerRequest.isVirtualOperator) {
            this.providerRequest.virtualOperatorId = null;
        }
    }

    public showapproveDialog() {
        this.approveDialog = true;
    }

    public hideapproveDialog() {
        this.approveDialog = false;
    }

    public showRejectDialog() {
        this.rejectdialog = true;
    }

    public hideRejectDialog() {
        this.rejectResone = '';
        this.rejectdialog = false;
    }

    private validateVirtualOperatorBeforeAction(): boolean {
        if (this.providerRequest.isVirtualOperator
            && (this.providerRequest.virtualOperatorId === null
                || this.providerRequest.virtualOperatorId === undefined
                || Number(this.providerRequest.virtualOperatorId) <= 0)) {
            Toaster.error(this.$t('shared.virtualOperatorRequired').toString());
            return false;
        }
        return true;
    }

    private buildVirtualOperatorPayload(): { isVirtualOperator: boolean; virtualOperatorId: number | null } {
        const isVirtualOperator = !!this.providerRequest.isVirtualOperator;
        let virtualOperatorId: number | null = null;
        if (isVirtualOperator
            && this.providerRequest.virtualOperatorId !== null
            && this.providerRequest.virtualOperatorId !== undefined) {
            virtualOperatorId = Number(this.providerRequest.virtualOperatorId);
        }
        return {
            isVirtualOperator,
            virtualOperatorId,
        };
    }

    public async approve() {
        if (!this.canEditVirtualOperator) {
            return;
        }
        if (!this.validateVirtualOperatorBeforeAction()) {
            return;
        }
        const vo = this.buildVirtualOperatorPayload();
        const response = await this.providerRequestsService.approve(
            this.providerRequest.id,
            vo.isVirtualOperator,
            vo.virtualOperatorId);
        if (response === false) {
            Toaster.error(this.$t('shared.errorOccurred').toString());
            return;
        }
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            return;
        }
        Toaster.success(this.$t('shared.ApprovedRequestSuccessfully').toString());
        this.hideapproveDialog();
        this.$router.push({ path: '/Providers/ProviderRequests' });
    }

    public async reject() {
        if (!this.canEditVirtualOperator) {
            return;
        }
        if (this.rejectResone === '') {
            return;
        }
        if (!this.validateVirtualOperatorBeforeAction()) {
            return;
        }
        const vo = this.buildVirtualOperatorPayload();
        const response = await this.providerRequestsService.reject(
            this.providerRequest.id,
            this.rejectResone,
            vo.isVirtualOperator,
            vo.virtualOperatorId);
        if (response === false) {
            Toaster.error(this.$t('shared.errorOccurred').toString());
            return;
        }
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            return;
        }
        Toaster.success(this.$t('shared.RejectedRequestSuccessfully').toString());
        this.hideRejectDialog();
        this.$router.push({ path: '/Providers/ProviderRequests' });
    }

    public async DownloadAttachment(att: ProviderRequestAttachment) {
        try {
            const base64 = att.fileContent || '';
            const bytes = Buffer.from(base64, 'base64');
            const mime = this.guessMime(att.fileName);
            const blob = new Blob([bytes], { type: mime });
            FileSaver.saveAs(blob, att.fileName || 'attachment');
        } catch (e) {
                const bytes = Buffer.from(att.fileContent || '', 'base64');
                const blob = new Blob([bytes]);
                FileSaver.saveAs(blob, att.fileName || 'attachment');
        }
    }
    public GetProviderRequestStatus(typeStatus: number) {
        typeStatus = typeStatus;
        switch (typeStatus) {
            case 1: {
                return 'Pending Approval';
                break;
            }
            case 2: {
                return 'Approved';
                break;
            }
            case 3: {
                return 'Rejected';
                break;
            }
        }
    }

    public labelFor(id: string) {
        const ZERO = '00000000-0000-0000-0000-000000000000';
        const map: Record<string, string> = {
            [ProviderAttachmentCategoryType.CstLicense]:
                this.$t('shared.cstLicense').toString(),
            [ProviderAttachmentCategoryType.CommercialRegistration]:
                this.$t('shared.commercialRegistration').toString(),
            [ProviderAttachmentCategoryType.DelegationLetter]:
                this.$t('shared.delegationLetter').toString(),
            [ProviderAttachmentCategoryType.NationalAddress]:
                this.$t('shared.nationalAddress').toString(),
            [ProviderAttachmentCategoryType.ZakatTaxCertificate]:
                this.$t('shared.zakatTaxCertificate').toString(),
        };
        const key = (id || '').toLowerCase();
        if (key === ZERO) {
            return this.$t('shared.delegationLetter').toString();
        }
        return map[id] || id;
    }

    private guessMime(name: string | undefined | null) {
        const ext = String(name || '').split('.').pop()!.toLowerCase();
        if (ext === 'pdf') { return 'application/pdf'; }
        if (ext === 'docx') { return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; }
        if (ext === 'doc') { return 'application/msword'; }
        return 'application/octet-stream';
    }
}
